import { useEffect } from 'react';

export default function ServerCard({ serverId, icon, serverName, onClick }) {   
    const hasIcon = icon ? true : false;

    // Adding different colours upon cursor hover
    useEffect(() => {
        const card = document.querySelector(`.server-card[data-server-name="${serverId}"]`);
        const colors = [
            'rgba(255, 166, 0, 0.5)',
            'rgb(175, 244, 255)',
            '#6decafff',
        ];

        const handleMouseEnter = () => {
            const randomColor = colors[Math.floor(Math.random() * colors.length)];
            card.style.boxShadow = `0 0 10px ${randomColor}`;
        };

        const handleMouseLeave = () => {
            card.style.boxShadow = 'none';
        };

        card.addEventListener('mouseenter', handleMouseEnter);
        card.addEventListener('mouseleave', handleMouseLeave);

        return () => {
            card.removeEventListener('mouseenter', handleMouseEnter);
            card.removeEventListener('mouseleave', handleMouseLeave);
        };
    }, [serverId]);


    return(
        <div
            className='server-card border p-5 border-black rounded-lg flex flex-col justify-around items-center w-52 h-72 text-center text-xl hover:bg-dimWhite translation-transform duration-100 hover:-translate-y-1 cursor-pointer'
            data-server-name={serverId} onClick={onClick}>
            <img className='rounded-full w-36' src={hasIcon ? icon : require('../images/discord_logo_large.png')} alt="Server Icon" />
            <h1>{serverName}</h1>
        </div>
    );
}